import React from 'react';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useActiveParticipantsFilter } from '../../../../data/hooks/participant/useActiveParticipantsFilter';
import { useParticipantsCategories } from '../../../../data/hooks/participant/useParticipantsCategories';
import MutualFavoritesHeader from '../../../elements/MutualFavoritesHeader/MutualFavoritesHeader';
import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import FilterSelection from '../elements/FilterSelection';
import ActiveSuggestionsInfo from './ActiveSuggestionsInfo/ActiveSuggestionsInfo';
import styles from './EventParticipantsHeader.module.scss';
import FilterHint from './FilterHint';
import ParticipantsTabs from './ParticipantsTabs';
import ParticipantsTextSearch from './ParticipantsTextSearch/ParticipantsTextSearch';

function EventParticipantsHeader(props) {
    const {eventId} = props,
        event = useEvent(eventId),
        categories = useParticipantsCategories(eventId),
        filterParams = useActiveParticipantsFilter(eventId);

    return (
        <div className={styles.EventParticipantsHeader}>
            <TopBarEvent event={event} participants={true} />
            <MutualFavoritesHeader eventId={eventId} />
            <ParticipantsTabs eventId={eventId} filterParams={filterParams} />
            <FilterHint eventId={eventId} filterParams={filterParams} />
            <ActiveSuggestionsInfo eventId={eventId} filterParams={filterParams} />
            <ParticipantsTextSearch eventId={eventId} filterParams={filterParams} />
            <FilterSelection event={event} categories={categories} filterParams={filterParams} />
        </div>
    );
}

export default EventParticipantsHeader;
